<template>
    <transition appear name="overlay-fade">
        <div id="overlay" class="overlay" v-if="active">
            <slot></slot>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        'active': Boolean,
    },
}
</script>
